
const anchorOrigin = {
    vertical: 'top',
    horizontal: 'right',
}

function NotiStackInfo(body, variant, enqueueSnackbar) {

    return enqueueSnackbar(body, {
        variant: variant,
        anchorOrigin: anchorOrigin
    })
}

function ErrorMessage(){

    return 'Ha ocurrido un error, por favor inténtelo nuevamente'
}



export {NotiStackInfo,  ErrorMessage}